import { defineMessages } from 'react-intl';

export default defineMessages({
  generalHeading: {
    id: 'frontbucket.workspace.settings.rovo-dev-agents-not-available',
    description: 'Message displayed when Rovo Dev Agents is not available.',
    defaultMessage: 'Rovo Dev Agents isn’t available in this workspace',
  },
  youNeedPaidHeading: {
    id: 'frontbucket.workspace.settings.rovo-dev-agents-only-available-on-paid-plans',
    description:
      'Message displayed when Rovo Dev Agents is not available on free plans.',
    defaultMessage:
      'Rovo Dev Agents is only available in standard or premium workspaces',
  },
  youNeedRDAHeading: {
    id: 'frontbucket.workspace.settings.rovo-dev-agents-app-is-not-installed-heading',
    description:
      'Heading displayed when Rovo Dev Agents is not installed but other requirements are met.',
    defaultMessage:
      'Rovo Dev Agents needs to be installed on your Atlassian site',
  },
  youNeedJiraHeading: {
    id: 'frontbucket.workspace.settings.only-jira-is-not-connected-heading',
    description:
      'Heading displayed when Jira is not connected but other requirements are met.',
    defaultMessage:
      'This workspace must be connected to Jira to use Rovo Dev Agents',
  },
  youNeedAllThree: {
    id: 'frontbucket.workspace.settings.you-need-all-three',
    description:
      'Message displayed when Rovo Dev Agents is not available and you need all 3 requirements.',
    defaultMessage:
      'To start using Rovo Dev Agents, you need Rovo Dev Agents installed on your Atlassian site, a workspace on a standard or premium plan, and the workspace must be connected to Jira.',
  },
  youNeedRDAAndJira: {
    id: 'frontbucket.workspace.settings.you-need-rovo-dev-agents-and-jira',
    description:
      'Message displayed when Rovo Dev Agents is not available and you need Rovo Dev Agents and Jira connected.',
    defaultMessage:
      'To start using Rovo Dev Agents, you need Rovo Dev Agents installed on your Atlassian site, and a workspace connected to Jira.',
  },
  youNeedPaidAndRDA: {
    id: 'frontbucket.workspace.settings.you-need-paid-and-rovo-dev-agents',
    description:
      'Message displayed when Rovo Dev Agents is not available and you need a paid plan and Rovo Dev Agents.',
    defaultMessage:
      'To start using Rovo Dev Agents, you need a workspace on a standard or premium plan, and Rovo Dev Agents installed on your Atlassian site.',
  },
  youNeedPaidAndJira: {
    id: 'frontbucket.workspace.settings.you-need-paid-and-jira',
    description:
      'Message displayed when Rovo Dev Agents is not available and you need a paid plan and Jira connected.',
    defaultMessage:
      'To start using Rovo Dev Agents, you need a workspace on a standard or premium plan, and the workspace must be connected to Jira.',
  },
  youNeedPaid: {
    id: 'frontbucket.workspace.settings.you-need-paid',
    description: 'Message displayed when you need a paid plan.',
    defaultMessage:
      'To start using Rovo Dev Agents, you need to use a workspace on a standard or premium plan.',
  },
  youNeedRDA: {
    id: 'frontbucket.workspace.settings.you-need-rovo-dev-agents',
    description: 'Message displayed when you need Rovo Dev Agents installed.',
    defaultMessage:
      'To start using Rovo Dev Agents, you need to install it on your Atlassian site.',
  },
  youNeedJira: {
    id: 'frontbucket.workspace.settings.you-need-jira',
    description: 'Message displayed when you need Jira connected.',
    defaultMessage:
      'To start using Rovo Dev Agents, you need to connect this workspace to Jira using DVCS.',
  },
  connectedWorkspace: {
    id: 'frontbucket.workspace.settings.connected-to-jira',
    description: 'Third item on the list of requirements or Rovo Dev Agents.',
    defaultMessage: 'Read how to connect a workspace to Jira',
  },
  rovoDevAgentsAppInstalled: {
    id: 'frontbucket.workspace.settings.rovo-dev-agents-installed',
    description: 'Second item on the list of requirements or Rovo Dev Agents.',
    defaultMessage: 'Read how to install Rovo Dev Agents',
  },
  bitbucketPlan: {
    id: 'frontbucket.workspace.settings.you-need-a-bitbucket-plan',
    description: 'First item on the list of requirements or Rovo Dev Agents.',
    defaultMessage: 'Discover Bitbucket plans and pricing',
  },
  spotPadlockKeyImageAlt: {
    id: 'frontbucket.workspace.settings.spot-padlock-key-image-alt',
    description: 'Alt text shown on image for the empty state of the page.',
    defaultMessage: 'Image showing a pad-lock with a key being inserted.',
  },
  additionalInstallInfoHeading: {
    id: 'frontbucket.workspace.settings.install-rovo-dev-agents-on-your-site-heading',
    description: 'Heading for the additional installation information callout.',
    defaultMessage: 'Install Rovo Dev Agents on your site',
  },
  additionalInstallInfoGoToIntro: {
    id: 'frontbucket.workspace.settings.install-rovo-dev-agents-go-to',
    description:
      'Intro line that instructs the user to visit a URL to install Rovo Dev Agents.',
    defaultMessage: 'Go to {link}',
  },
  tryCloudDevAIBundleUrl: {
    id: 'frontbucket.workspace.settings.install-rovo-dev-agents-devai-url',
    description:
      'URL shown to direct the user to the Dev AI signup/install page.',
    defaultMessage: 'https://www.atlassian.com/try/cloud/signup?bundle=devai',
  },
  additionalInstallStep1: {
    id: 'frontbucket.workspace.settings.install-rovo-dev-agents-step-1',
    description: 'First step for installing Rovo Dev Agents on the site.',
    defaultMessage:
      'Log in with your Atlassian details, or sign up and create a new site. If you already have multiple sites, select the site you want to install Rovo Dev Agents on.',
  },
  additionalInstallStep2: {
    id: 'frontbucket.workspace.settings.install-rovo-dev-agents-step-2',
    description: 'Second step for installing Rovo Dev Agents on the site.',
    defaultMessage: 'Select Agree and start now.',
  },
  additionalInstallStep3: {
    id: 'frontbucket.workspace.settings.install-rovo-dev-agents-step-3',
    description: 'Third step for installing Rovo Dev Agents on the site.',
    defaultMessage:
      'Once the installation is complete, select Go to Rovo Dev Agents.',
  },
});
